import { Home, Error500, Error404, List, Admin } from './pages'
import store from './store'

const routes = [
  { path: "/",
    name: "Home",
    component: Home,
    meta: {title: 'HipCabin'},
  },
  { path: "/admin", name: "Admin", component: Admin, meta: { title: 'Admin' }},
  { 
    path: "/:category", 
    name: "List", 
    component: List, 
    meta: { title: 'Unique and Essential Goods for Bnbs' },
    beforeEnter: (to, from, next) => {
      console.log('.........', store.state.resource)
      store.state.resource.filter = {}
      next()
    }
  },
  { path: "/404", name: "Error 404", component: Error404, meta: { title: 'Page Not Found' }},
  { path: "/500", name: "Error 500", component: Error500, meta: { title: 'Server Error' }},
  { //otherwise 404
    path: '*',
    component: Error404
  }
];

export default routes;
